module.exports = ".card-class {\n  padding: 10px; }\n\n.card-title {\n  font-weight: 700; }\n\n.radius {\n  border-radius: 5px; }\n\n.custom-alert-success {\n  color: #003300;\n  background-color: #ccffcc;\n  border-radius: 20px;\n  padding: 2px; }\n\n.custom-alert-danger {\n  color: #330000;\n  background-color: #ffcccc;\n  border-radius: 20px;\n  padding: 3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/uploaded-order/uploaded-order.component.scss
// module id = ./src/app/admin/uploaded-order/uploaded-order.component.scss
// module chunks = main